import { render, staticRenderFns } from "./AbilityScoreFields.vue?vue&type=template&id=853349da"
import script from "./AbilityScoreFields.vue?vue&type=script&lang=js"
export * from "./AbilityScoreFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports